import {GetterTree} from "vuex";
import {RootState} from "@/store/types";
import {PharmaciesGetters, PharmaciesState} from "@/store/pharmacies/types";

const getters: GetterTree<PharmaciesState, RootState> & PharmaciesGetters = {
    pharmacies: state => state.pharmacies_arr,
    pharmUsers: state => state.pharm_users,
    pharmId: state => state.pharmId,
    FRV: state => state.FRV,
    FRVHuman:  state => state.FRV_human,
    coreStaff: state => state.corestaff_count_panel,
    FRV_RV: state => state.frv_rv_count_panel,
    beruCoreStaff: state => state.beru_corestaff_count_panel,
    beruFRV_RV: state => state.beru_frv_rv_count_panel,
    beruHolidays: state => state.beru_holidays,
    timeSchedule: state => state.time_schedule,
    timeScheduleKeys: state => state.time_schedule_key,
    timeScheduleDetailsPast: state => state.time_schedule_details_past,
    holidays: state => state.pharm_holidays,
    shiftExistence: state => state.shift_existence,
    adminShift: state => state.admin_shift,
    pharmSchedule: state => state.pharm_schedule,
    errorModal: state => state.error_modal,
    pharmsList: state => state.pharms_list,
    pharmsListCount: state => state.pharms_count,
    pharmsSearchQuery: state => state.pharms_search,
    newSearchUsersCount: state => state.search_user_count,
    newSearchUsersSkip: state => state.search_user_skip,
    newSearchUserList: state => state.search_user_list,
    shiftInfo: state => state.shift_info,
    pharmTz: state => state.pharmTz,
    tomorrowWorkTime: state => state.tomorrow_worktime,
}

export default getters